export default __webpack_public_path__ + "static/media/eye.af0ed64e.svg";